module.exports = __webpack_public_path__ + "static/img/ls4.234fa0a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark2/ls4.png
// module id = uy+Z
// module chunks = 12